import './SelectReportExecution.css'
import i18n from 'i18n'
import * as React from "react"
import { IconSeekers, SelectAjaxSeeker } from "ui-seeker/core"
import { AppUserTimestamp } from "app/@components"
import { useHistoricalExecutionNotice } from "app/@hooks"

const formatOptionLabel = (option, { context }) => {
    // label = "name (ts_local)"; ts_local/tz come from the backend (user timezone)
    const labelTs = option.ts_local || option.ts
    const name = labelTs ? option.label.replace(` (${labelTs})`, '').trim() : option.label

    if (context === 'value') return <span style={{ fontSize: '13px' }}>{name}</span>

    return <div style={{ padding: '2px 0', lineHeight: 1.3 }}>
        <div style={{ fontWeight: 600, fontSize: '13px', color: '#1f2937' }}>{name}</div>
        {labelTs && <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px' }}><AppUserTimestamp local={option.ts_local} tz={option.tz} utc={option.ts} /></div>}
        {option.historical && <div className="report-execution-historical-badge">
            <IconSeekers icon="history" iconType="fontAwesome" />
            <span>{i18n.t('common:reportExecution.historical.badge')}</span>
        </div>}
    </div>
}

export default function SelectReportExecution({ onChange, onAjax, ...props }) {
    // Historical executions (older than the CH retention) load from BigQuery: toaster once + header badge
    // (AppHistoricalExecutionBadge, left of "Last update")
    const historical = useHistoricalExecutionNotice(props.value)

    const myProps = {
        isSearchable: false,
        placeholder: i18n.t('common:filters.selectReportExecution'),
        icon: { icon: 'file-alt' },
        isMulti: false,
        isClearable: true,
        formatOptionLabel,
        ...props,
        onChange: option => {
            historical.onChange(option)
            if (onChange) onChange(option)
        },
        onAjax: options => {
            const out = onAjax ? onAjax(options) : options
            historical.onAjax(out)
            return out
        }
    }

    return <SelectAjaxSeeker {...myProps} />
}
